import { useContext, useMemo } from 'react';
import {
  createInitialSummaryGenerationStatus,
  SummaryStatusContext,
  SummaryStatusContextValue,
} from './types';

export const useSummaryStatus = (): SummaryStatusContextValue => {
  const context = useContext(SummaryStatusContext);

  // Memoize the default no-op context to maintain stable references
  // and avoid infinite rendering loops when used outside a provider
  const defaultContext = useMemo<SummaryStatusContextValue>(
    () => ({
      summaryStatus: createInitialSummaryGenerationStatus(),
      setSummaryStatus: () => {},
      enpsData: null,
      engagementData: null,
      setEnpsData: () => {},
      setEngagementData: () => {},
    }),
    []
  );

  return context ?? defaultContext;
};
